// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const setShouldRenderComponent =
	(shouldRenderComponent: boolean): Action<State> =>
	({ getState, setState }) => {
		/* Grab current state of is shouldRenderComponent */
		const { shouldRenderComponent: currentShouldRenderComponent } = getState();
		if (shouldRenderComponent === currentShouldRenderComponent) {
			// if state has not been updated we just return
			return;
		}

		setState({ shouldRenderComponent });
	};

export default setShouldRenderComponent;
